"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.variableConfig = exports.createVariableNode = exports.isVariableNode = void 0;
var react_1 = __importDefault(require("react"));
var slate_1 = require("slate");
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var Text_1 = require("@CommonFrontend/ContentTokens/DataModels/Text");
var Variable_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Variable/Variable");
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var SubstitutionTokenFactory_1 = __importDefault(require("@CommonFrontend/Tokens/SubstitutionTokenFactory"));
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var NormalizeVoidNode_1 = require("Project/QwilrEditor/Schemas/NormalizeVoidNode");
var MakeConfig_1 = require("../Utils/MakeConfig");
var isVariableNode = function (node) {
    return slate_1.Element.isElement(node) && node.type === "variable";
};
exports.isVariableNode = isVariableNode;
var createVariableNode = function (token) {
    return {
        type: "variable",
        data: {
            variableName: token.apiName,
            variableLabel: token.name,
            isBold: false,
            isItalic: false,
            isStrikethrough: false,
            providerType: token.providerType,
            substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(token),
        },
        children: [Text_1.text.createSlateJson()],
        isVoid: true,
    };
};
exports.createVariableNode = createVariableNode;
var variableConfig = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("variable")), { node: {}, nodeType: "void", editorRender: VariableWidget, serialise: function (node) {
        return [
            __assign({ type: "inline", subType: "variable", isBold: node.data.isBold, isItalic: node.data.isItalic, isStrikethrough: node.data.isStrikethrough, providerType: node.data.providerType, label: node.data.variableLabel.trim(), name: node.data.variableName.trim() }, (0, CommonUtils_1.includeIf)(!!node.data.substitutionToken, { substitutionToken: node.data.substitutionToken })),
        ];
    }, deserialise: function (token) {
        return {
            type: "variable",
            isVoid: true,
            data: __assign({ variableName: token.name, variableLabel: token.label, isBold: token.isBold, isItalic: token.isItalic, isStrikethrough: token.isStrikethrough, providerType: token.providerType }, (0, CommonUtils_1.includeIf)(!!token.substitutionToken, { substitutionToken: token.substitutionToken })),
            children: [Text_1.text.createSlateJson()],
        };
    }, normalizeWidget: NormalizeVoidNode_1.normalizeVoidNode, firstLastConfiguration: {
        isValidFirstChild: false,
    }, validEditors: ["standard", "agreement", "quotePlanCard", "quote", "quoteLineItem", "quotePlanCardFeatureList"], validContainers: ["heading1", "heading2", "paragraph"], toolbarButtons: VariableToolbarButtons, onAddWidget: function () { }, width: "fit-widget" }));
exports.variableConfig = variableConfig;
function VariableWidget(_a) {
    var _b, _c, _d;
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    return (react_1.default.createElement("span", { contentEditable: false },
        react_1.default.createElement(Variable_1.Variable, { label: element.data.variableLabel, isBold: (_b = element.data.isBold) !== null && _b !== void 0 ? _b : false, isItalic: (_c = element.data.isItalic) !== null && _c !== void 0 ? _c : false, isStrikethrough: (_d = element.data.isStrikethrough) !== null && _d !== void 0 ? _d : false, attributes: attributes }, children)));
}
function VariableToolbarButtons(_a) {
    var element = _a.element;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var createAction = function (action) { return function () {
        return widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("variable", {
            action: action,
            path: widgetManager.getPath(element),
        }));
    }; };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Bold, null), selected: element.data.isBold, onClick: createAction(EditorTypes_1.VariableActionType.Bold) }),
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Italic, null), selected: element.data.isItalic, onClick: createAction(EditorTypes_1.VariableActionType.Italic) }),
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Strikethrough, null), selected: element.data.isStrikethrough, onClick: createAction(EditorTypes_1.VariableActionType.Strikethrough) })));
}
